import { useAccountAttributeElement, usePrevious } from 'affiny-core/hooks';
import usePageViews from 'affiny-desktop/src/hooks/page-views';
import { RoutesNames } from 'affiny-desktop/src/routes/routes-names';
import { WebRoutes } from 'affiny-web/src/routes';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import NotFoundComponent from 'affiny-desktop/src/pages/desktop/NotFound';

const RedirectAfterUsingBackButton = () => {
  const location = useLocation();
  /* We need to kwnow the previons location pathname */
  const prevLocationPathname = usePrevious(location.pathname);
  const hasCompletedProfile = useAccountAttributeElement('hasCompletedProfile');
  const history = useHistory();

  const isInProfileCapture = (path: string) => {
    return Object.values(WebRoutes).filter(route => path.startsWith(route))
      .length;
  };

  if (
    /* We check the previous location pathname and the current location pathname:
      - if we come back from Home to PC, we redirect user to Home
      - if we come back from any page and the current page is '/' */
    prevLocationPathname &&
    (((prevLocationPathname.startsWith(RoutesNames.Home) ||
      (prevLocationPathname === RoutesNames.Login && hasCompletedProfile)) &&
      isInProfileCapture(location.pathname)) ||
      (isInProfileCapture(prevLocationPathname) &&
        location.pathname === RoutesNames.Login) ||
      /* User clicked on back Button from browser more than once */
      OnPageChange.hasUsedBackButton)
  ) {
    /* We prevent to execute the redirection as many times as he clicked on teh back button 
          We want to execute the redirection only once */
    if (!OnPageChange.hasUsedBackButton) {
      setTimeout(() => {
        OnPageChange.hasUsedBackButton = false;
        history.push(
          prevLocationPathname ? prevLocationPathname : RoutesNames.Home
        );
      }, 3000);
    }

    OnPageChange.hasUsedBackButton = true;
  }

  return prevLocationPathname;
};

interface IProps {
  children: JSX.Element;
}

export const OnPageChange = ({ children }: IProps) => {
  const location = useLocation();

  usePageViews();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const prevLocationPathname = RedirectAfterUsingBackButton();

  if (OnPageChange.hasUsedBackButton) {
    return (
      <NotFoundComponent hasLogo prevLocationPathname={prevLocationPathname} />
    );
  }

  return children;
};

/* create static variable 
   variable keep value enven if you call it several times */
OnPageChange.hasUsedBackButton = false;
